// extracted by mini-css-extract-plugin
module.exports =  {"container":"WatmXXfs9ddZvSfkwRQk"};